﻿import { onReady } from './util/onReady';

function setupAccordion() {
    const container = document.querySelector('.research-items-list');
    if (!container) return;

    const buttons = container.querySelectorAll<HTMLButtonElement>('.accordion-button-container');

    // Check if content is clamped and hide button if not needed
    buttons.forEach((button) => {
        const targetId = button.getAttribute('aria-controls');
        if (!targetId) return;

        const element = document.getElementById(targetId);
        if (!element) return;

        // Check if the text is actually clamped
        const isTextClamped = element.scrollHeight - 1 > element.clientHeight;
        if (!isTextClamped) {
            button.classList.add('hide');
            return;
        }

        button.addEventListener('click', () => {
            const isHidden = element.classList.contains('hideExtra');
            element.classList.toggle('hideExtra');

            button.setAttribute('aria-expanded', isHidden.toString());
            const newLabel = isHidden ? button.dataset.hideSummary : button.dataset.showSummary;
            if (newLabel) button.setAttribute('aria-label', newLabel);
        });
    });
}

onReady(() => {
    setupAccordion();
});
